var _desc, _defs, _rect, _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageTitleHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 471,
    height: 296,
    viewBox: "4 270 471 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.6082 0 0 -1.7218 336.1807 181.118)",
    id: 653011
  }, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "SVGID_152",
    y: "-20%",
    height: "140%",
    x: "-20%",
    width: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "oBlur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "oBlur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1,
      filter: "url(#SVGID_152)"
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -5.1936)",
    d: "M 6.76364 9.92029 C 7.16364 9.88139 7.6 9.84248 8 9.80357 C 8.4 9.80357 8.76364 9.76467 9.16364 9.76467 C 11.2727 9.68686 13.3818 9.57016 15.4909 9.53126 C 17.7091 9.49236 19.9273 9.45345 22.1091 9.41454 C 24.3636 9.41454 26.6182 9.41454 28.8727 9.41454 C 33.2727 9.45345 37.6727 9.45345 42.0727 9.45345 C 46.4364 9.45345 50.8 9.45345 55.1636 9.45345 C 57.3455 9.45345 59.4909 9.37565 61.6727 9.33674 C 63.8182 9.29784 65.9273 9.22003 68.0364 9.14223 C 68.5091 9.14223 68.9818 9.10332 69.4545 9.06442 C 69.9273 9.02551 70.3636 9.02551 70.8364 8.98661 C 72.0364 8.9088 73.2 8.7921 74.3636 8.67539 C 76.4364 8.48087 78.4727 8.20855 80.5455 8.05293 C 82.6909 7.89732 84.8727 7.78061 87.0182 7.625 C 88 7.54719 88.9818 7.46939 89.9273 7.35268 C 91.0182 7.19707 92.1455 7.00255 93.2364 6.76914 C 94.2909 6.53572 95.3455 6.30229 96.4 6.06887 C 96.9091 5.95216 97.4182 5.87437 97.9273 5.79656 C 98.5091 5.71875 99.0909 5.60204 99.6727 5.48533 C 99.9636 5.40752 100 5.01849 100 4.78508 C 100 4.62946 99.9636 4.51275 99.9273 4.35714 C 99.8909 4.24043 99.8182 4.04592 99.6727 4.08483 C 98.6545 4.12373 97.6 4.16263 96.5818 4.20153 C 95.5273 4.24043 94.5091 4.27933 93.4546 4.31823 C 91.4182 4.35714 89.3818 4.27934 87.3818 4.20153 C 87.7091 4.16263 88.0727 4.08482 88.4 4.04592 C 89.6364 3.8514 90.8727 3.65688 92.1091 3.54017 C 92.7636 3.46237 93.4545 3.42346 94.1091 3.34566 C 94.4364 3.30675 94.7636 3.26785 95.0909 3.19005 C 95.4546 3.11224 95.7818 2.99554 96.1455 2.91773 C 96.2546 2.91773 96.3273 2.83993 96.4 2.72322 C 96.5091 2.5676 96.5454 2.37308 96.5818 2.17856 C 96.9454 2.06185 97.0182 1.51722 97.0182 1.16709 C 97.0182 0.972577 96.9818 0.77806 96.9091 0.544641 C 96.8364 0.389029 96.7273 0.116705 96.5091 0.116705 C 95.4182 0.116705 94.3636 0.0389031 93.2727 0 C 93.1636 0 93.0182 0 92.9091 0 C 92 0 91.0546 0.038896 90.1455 0.0777991 C 88.0727 0.194508 86.0364 0.350123 83.9636 0.505736 C 83.0182 0.583542 82.0364 0.66135 81.0909 0.739156 C 79.9273 0.816963 78.7636 0.855866 77.5636 0.933672 C 75.6 1.01148 73.6364 1.05038 71.6727 1.08928 C 69.4182 1.12819 67.1636 1.20599 64.9454 1.3227 C 62.8727 1.43941 60.8 1.55612 58.6909 1.71173 C 56.6182 1.82844 54.5091 1.98406 52.4364 2.10076 C 50.2909 2.25638 48.1455 2.33418 46 2.45089 C 44.9091 2.48979 43.8182 2.52869 42.7273 2.56759 C 41.7091 2.6065 40.6909 2.6065 39.6364 2.6065 C 37.6 2.6454 35.6 2.64541 33.5636 2.68431 C 29.4909 2.72321 25.4182 2.80102 21.3455 2.87883 C 19.0909 2.91773 16.8727 2.95663 14.6182 2.99553 C 13.4909 3.03443 12.3273 3.07334 11.2 3.11225 C 10.2182 3.15115 9.23637 3.22895 8.25455 3.26786 C 7.2 3.30676 6.18182 3.38457 5.12727 3.46237 C 4.50909 3.50128 3.89091 3.54017 3.27273 3.57908 C 3.01818 3.57908 2.72727 3.61798 2.47272 3.61798 C 2.21818 3.61798 2 3.65689 1.74545 3.65689 C 1.56363 3.65689 1.38182 3.69578 1.23636 3.73469 C 1.05454 3.77359 0.872723 3.8514 0.654541 3.9292 C 0.54545 4.00701 0.472732 4.12373 0.436368 4.27934 C 0.363641 4.47386 0.327273 4.66837 0.363636 4.86289 C 0.363636 5.0574 0.400004 5.25192 0.436368 5.44643 C 0.472732 5.52424 0.509091 5.60204 0.545455 5.67984 C 0.618182 5.79655 0.690905 5.87436 0.836359 5.87436 C 1.05454 5.95216 1.27273 5.99108 1.49091 6.02998 C 1.6 6.02998 1.70909 5.95217 1.78182 5.83546 C 1.81818 5.79656 1.81818 5.75765 1.85455 5.71875 C 1.96364 5.71875 2.07273 5.71875 2.18182 5.71875 C 2.29091 5.71875 2.4 5.71875 2.50909 5.71875 C 2.76363 5.71875 3.01818 5.71875 3.23636 5.71875 C 3.85454 5.71875 4.50909 5.67984 5.12727 5.67984 C 5.81818 5.67984 6.50909 5.64095 7.2 5.64095 C 7.12727 5.64095 7.05455 5.64095 6.98182 5.64095 C 5.34546 5.75766 3.74545 5.91326 2.10909 6.06887 C 1.85454 6.10778 1.63637 6.22449 1.49091 6.49681 C 1.27273 6.80803 1.16364 7.15817 1.12727 7.5472 C 0.836366 7.5472 0.545459 7.5472 0.25455 7.5472 C 0.0363681 7.5472 0 7.93622 0 8.05293 C 0 8.20855 0.0363681 8.55868 0.25455 8.55868 C 0.545459 8.55868 0.8 8.55868 1.09091 8.55868 C 1.12727 8.86991 1.16364 9.18113 1.27273 9.49235 C 1.34545 9.64797 1.41818 9.80357 1.49091 9.95918 C 1.63637 10.1926 1.81818 10.3482 2.10909 10.3871 C 3.70909 10.1926 5.23637 10.0759 6.76364 9.92029 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.0765 0.2748 -0.1975 1.4926 203.9015 202.5888)",
    id: 184054
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.3039 0 0 2.2558 -26.6694 0.4144)",
    id: "Vector",
    clipPath: "url(#CLIPPATH_153)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_153"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 7.5555 -0.6842)",
    id: "clip0",
    x: -28,
    y: -13,
    rx: 0,
    ry: 0,
    width: 56,
    height: 26
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-20.4445, -13.6842)",
    d: "M 36.9746 4.74681 C 37.5228 6.17719 36.844 6.45567 35.4603 6.84808 C 32.4781 7.73664 29.5588 8.81277 26.7209 10.0696 C 22.844 11.7342 19.065 13.6076 15.2142 15.3417 C 12.7862 16.4557 10.9261 18.3544 8.61559 19.5569 C 6.56617 20.6266 5.22165 22.2974 3.73354 23.8607 C 3.49857 24.1139 3.38762 24.4936 3.14612 24.7152 C 2.74146 25.1202 3.34193 26.3861 1.84076 25.8861 C 0.535401 25.4557 -0.221709 24.9493 0.0654707 23.5569 C 0.483186 21.519 1.95824 20.1582 3.43983 18.8228 C 7.57783 15.0253 12.4729 12.3481 17.3876 9.70251 C 22.5825 6.93445 28.0484 4.67438 33.7046 2.95567 C 36.0282 2.24681 38.3582 1.39238 40.8841 1.36707 C 39.7093 2.37972 38.1429 2.48732 36.7592 2.99998 C 35.2189 3.5696 33.6263 4.00631 32.0534 4.47466 C 31.5769 4.62023 31.1396 4.75314 31.1004 5.32909 C 30.8655 5.2658 30.6175 5.12023 30.4478 5.17086 C 26.9433 6.10581 23.5797 7.48029 20.4422 9.25947 C 20.168 9.41137 20.3704 9.66453 20.4095 9.86074 C 20.2812 9.73651 20.117 9.65303 19.9387 9.62138 C 19.7603 9.58973 19.5763 9.6114 19.4109 9.68352 C 17.0809 10.8671 14.6529 11.8987 12.61 13.5823 C 15.3382 12.5886 17.5834 10.6519 20.3965 9.84175 C 23.7983 8.00729 27.374 6.49401 31.0743 5.32276 C 32.0468 4.96833 33.0324 4.59491 33.9918 4.25314 C 34.8403 3.962 34.762 4.04428 35.4603 4.79112 C 35.7606 5.10757 36.4655 4.962 36.9746 4.75314 V 4.74681 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.3039 0 0 2.2558 58.0285 -23.61)",
    id: "Vector_2",
    clipPath: "url(#CLIPPATH_154)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_154"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -18.0805 9.9659)",
    id: "clip0",
    x: -28,
    y: -13,
    rx: 0,
    ry: 0,
    width: 56,
    height: 26
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-46.0805, -3.0341)",
    d: "M 36.9743 4.75321 C 37.3528 4.96207 37.7249 4.87979 37.8032 4.49371 C 37.8815 4.10764 37.516 4.06333 37.1505 4.12662 C 36.785 4.18992 36.5044 4.43042 36.1323 3.79751 C 37.4529 3.07379 38.9495 2.70662 40.4661 2.73422 C 41.5822 2.73422 42.6787 1.41143 43.9123 2.6646 C 44.1342 2.89245 44.4083 1.49371 45.3808 1.48106 C 46.5426 1.48106 47.7109 1.08865 48.8661 1.11397 C 50.8242 1.15827 52.6647 0.481055 54.6097 0.626625 C 55.1514 0.664599 55.6801 0.51903 55.9608 1.11397 C 56.0298 1.27297 56.0468 1.4487 56.0094 1.61737 C 55.9721 1.78604 55.8822 1.93951 55.7519 2.057 C 55.3016 0.87346 54.7272 3.63928 54.2377 2.00004 C 54.0223 1.29751 53.6633 1.94941 53.5067 2.09498 C 52.7561 2.80384 51.503 2.15827 50.7915 3.10131 C 50.6545 3.28485 49.9039 2.8608 49.9561 2.27852 C 50.0344 1.3165 49.3034 1.55068 48.8988 1.69624 C 48.1286 1.95574 48.8988 2.22789 48.9379 2.53169 C 49.2055 3.79751 47.9719 3.70257 47.3911 3.73422 C 46.1575 3.79751 44.9957 3.62662 43.9253 4.58232 C 43.2727 5.21523 43.227 3.84181 42.4307 3.85447 C 42.279 4.22337 42.0489 4.55716 41.7554 4.83413 C 41.4619 5.11111 41.1116 5.32506 40.7272 5.46207 C 40.4009 5.03169 41.2232 4.51903 40.5444 4.057 C 39.4349 4.32283 38.5342 6.38612 36.9743 4.74688 V 4.75321 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.3039 0 0 2.2558 60.7854 -29.5008)",
    id: "Vector_3",
    clipPath: "url(#CLIPPATH_155)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_155"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -18.9151 12.5774)",
    id: "clip0",
    x: -28,
    y: -13,
    rx: 0,
    ry: 0,
    width: 56,
    height: 26
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-46.9151, -0.4226)",
    d: "M 48.8731 0 C 47.8223 0.841772 46.5953 0.917721 44.957 0.803797 C 46.3407 -0.322785 47.6461 0.183544 48.8731 0 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.0764 0.2748 -0.1975 1.4925 223.7348 211.5135)",
    id: 755746
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.3039 0 0 2.2558 -26.6694 0.4144)",
    id: "Vector",
    clipPath: "url(#CLIPPATH_156)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_156"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 7.5555 -0.6842)",
    id: "clip0",
    x: -28,
    y: -13,
    rx: 0,
    ry: 0,
    width: 56,
    height: 26
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(214,225,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-20.4445, -13.6842)",
    d: "M 36.9746 4.74681 C 37.5228 6.17719 36.844 6.45567 35.4603 6.84808 C 32.4781 7.73664 29.5588 8.81277 26.7209 10.0696 C 22.844 11.7342 19.065 13.6076 15.2142 15.3417 C 12.7862 16.4557 10.9261 18.3544 8.61559 19.5569 C 6.56617 20.6266 5.22165 22.2974 3.73354 23.8607 C 3.49857 24.1139 3.38762 24.4936 3.14612 24.7152 C 2.74146 25.1202 3.34193 26.3861 1.84076 25.8861 C 0.535401 25.4557 -0.221709 24.9493 0.0654707 23.5569 C 0.483186 21.519 1.95824 20.1582 3.43983 18.8228 C 7.57783 15.0253 12.4729 12.3481 17.3876 9.70251 C 22.5825 6.93445 28.0484 4.67438 33.7046 2.95567 C 36.0282 2.24681 38.3582 1.39238 40.8841 1.36707 C 39.7093 2.37972 38.1429 2.48732 36.7592 2.99998 C 35.2189 3.5696 33.6263 4.00631 32.0534 4.47466 C 31.5769 4.62023 31.1396 4.75314 31.1004 5.32909 C 30.8655 5.2658 30.6175 5.12023 30.4478 5.17086 C 26.9433 6.10581 23.5797 7.48029 20.4422 9.25947 C 20.168 9.41137 20.3704 9.66453 20.4095 9.86074 C 20.2812 9.73651 20.117 9.65303 19.9387 9.62138 C 19.7603 9.58973 19.5763 9.6114 19.4109 9.68352 C 17.0809 10.8671 14.6529 11.8987 12.61 13.5823 C 15.3382 12.5886 17.5834 10.6519 20.3965 9.84175 C 23.7983 8.00729 27.374 6.49401 31.0743 5.32276 C 32.0468 4.96833 33.0324 4.59491 33.9918 4.25314 C 34.8403 3.962 34.762 4.04428 35.4603 4.79112 C 35.7606 5.10757 36.4655 4.962 36.9746 4.75314 V 4.74681 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.3039 0 0 2.2558 58.0285 -23.61)",
    id: "Vector_2",
    clipPath: "url(#CLIPPATH_157)"
  }, _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_157"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -18.0805 9.9659)",
    id: "clip0",
    x: -28,
    y: -13,
    rx: 0,
    ry: 0,
    width: 56,
    height: 26
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(214,225,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-46.0805, -3.0341)",
    d: "M 36.9743 4.75321 C 37.3528 4.96207 37.7249 4.87979 37.8032 4.49371 C 37.8815 4.10764 37.516 4.06333 37.1505 4.12662 C 36.785 4.18992 36.5044 4.43042 36.1323 3.79751 C 37.4529 3.07379 38.9495 2.70662 40.4661 2.73422 C 41.5822 2.73422 42.6787 1.41143 43.9123 2.6646 C 44.1342 2.89245 44.4083 1.49371 45.3808 1.48106 C 46.5426 1.48106 47.7109 1.08865 48.8661 1.11397 C 50.8242 1.15827 52.6647 0.481055 54.6097 0.626625 C 55.1514 0.664599 55.6801 0.51903 55.9608 1.11397 C 56.0298 1.27297 56.0468 1.4487 56.0094 1.61737 C 55.9721 1.78604 55.8822 1.93951 55.7519 2.057 C 55.3016 0.87346 54.7272 3.63928 54.2377 2.00004 C 54.0223 1.29751 53.6633 1.94941 53.5067 2.09498 C 52.7561 2.80384 51.503 2.15827 50.7915 3.10131 C 50.6545 3.28485 49.9039 2.8608 49.9561 2.27852 C 50.0344 1.3165 49.3034 1.55068 48.8988 1.69624 C 48.1286 1.95574 48.8988 2.22789 48.9379 2.53169 C 49.2055 3.79751 47.9719 3.70257 47.3911 3.73422 C 46.1575 3.79751 44.9957 3.62662 43.9253 4.58232 C 43.2727 5.21523 43.227 3.84181 42.4307 3.85447 C 42.279 4.22337 42.0489 4.55716 41.7554 4.83413 C 41.4619 5.11111 41.1116 5.32506 40.7272 5.46207 C 40.4009 5.03169 41.2232 4.51903 40.5444 4.057 C 39.4349 4.32283 38.5342 6.38612 36.9743 4.74688 V 4.75321 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.3039 0 0 2.2558 60.7854 -29.5008)",
    id: "Vector_3",
    clipPath: "url(#CLIPPATH_158)"
  }, _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_158"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -18.9151 12.5774)",
    id: "clip0",
    x: -28,
    y: -13,
    rx: 0,
    ry: 0,
    width: 56,
    height: 26
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(214,225,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-46.9151, -0.4226)",
    d: "M 48.8731 0 C 47.8223 0.841772 46.5953 0.917721 44.957 0.803797 C 46.3407 -0.322785 47.6461 0.183544 48.8731 0 Z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageTitleHeader);
export default __webpack_public_path__ + "static/media/ImageTitleHeader.247b8a3100b24ad1c6ba04dcf901d872.svg";
export { ForwardRef as ReactComponent };